module.exports = __webpack_public_path__ + "static/media/dungeon_floor_nw.6ec95198.png";